import makeDoFetchJiraIssues from 'ducks/integrations/jiraShared/operations/makeDoFetchJiraIssues'

export default makeDoFetchJiraIssues(
  'integrations/jira_server',
  () => `proxy/jira-server/rest/api/2/search`
)
